<mat-form-field class="form-field" [appearance]="appearance">
    
    <mat-label>
        {{label}}
    </mat-label>

    <mat-select [formControl]="formControl">
        <mat-option *ngFor="let category of categories" [value]="category.categoryid">
            {{category.categoryname}}
        </mat-option>
    </mat-select>

</mat-form-field>